export default "__VITE_ASSET__CG8aWAKt__"